import React from "react"
import { Link } from "gatsby"
import windraw from '../../../images/enter-prize-draw.png'
import "./WinDraw.scss"

const WinDraw = () => {
	return (
		<div className="win-draw sticker">
		
				<h1>...ENTER OUR PRIZE DRAW</h1>
				<p>Once your child has collected all the Episode stickers, this Dashboard will update allowing you to enter them into our prize draw to win an Xbox X.
				<Link className="link link-primary arrow" to={`/terms/`}
				data-analytics={`{ "event" : "prize_draw_details", "actionType" : "Link Click", "loginStatus": "logged-in", "clickText" : "Prize draw details", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}/terms/", "pageName" : "Grown up Dashboard" , "moduleName" : "Grown-up Dashboard - Engagement", "userType" : "parent" }`}>Prize draw details</Link></p>
                <div className="windrawimg reveal-img">
					{/* <h4>WIN</h4>
					<h4 className="ps5">PS5</h4> */}
					<img alt="Xbox X" src={windraw} className="big-reveal"/>
				</div>
		</div>
	)
}

export default WinDraw
